import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ShareWithCardRouteInfoQueryVariables = Types.Exact<{
  draftsInput: Types.StationeryDraftsByEventInput;
  orderFilters: Types.StationeryPrintOrdersFiltersInput;
}>;

export type ShareWithCardRouteInfoQuery = {
  __typename?: 'Query';
  stationeryPrintOrders: {
    __typename?: 'StationeryPrintOrdersView';
    orders: Array<{
      __typename?: 'StationeryPrintOrder';
      id: string;
      currentStatus: Types.StationeryPrintOrderStatusEnum;
      cardDraft?: {
        __typename?: 'StationeryDraft';
        id: string;
        stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; category: Types.StationeryTemplateCategoryEnum };
      } | null;
    }>;
  };
  stationeryDraftsByEvent: Array<{
    __typename?: 'StationeryDraft';
    id: string;
    stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; category: Types.StationeryTemplateCategoryEnum };
  }>;
};

export type ShareWebsiteUpdateEventHandleMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  website: Types.Scalars['String'];
}>;

export type ShareWebsiteUpdateEventHandleMutation = { __typename?: 'Mutation'; updateWebsiteHandle: { __typename?: 'Event'; id: string; website: string } };

export const ShareWithCardRouteInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShareWithCardRouteInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftsInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryDraftsByEventInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilters' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrdersFiltersInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrders' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filters' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilters' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardDraft' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stationeryTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryDraftsByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'draftsInput' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShareWithCardRouteInfoQuery__
 *
 * To run a query within a React component, call `useShareWithCardRouteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareWithCardRouteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareWithCardRouteInfoQuery({
 *   variables: {
 *      draftsInput: // value for 'draftsInput'
 *      orderFilters: // value for 'orderFilters'
 *   },
 * });
 */
export function useShareWithCardRouteInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShareWithCardRouteInfoQuery, ShareWithCardRouteInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<ShareWithCardRouteInfoQuery, ShareWithCardRouteInfoQueryVariables>(ShareWithCardRouteInfoDocument, baseOptions);
}
export function useShareWithCardRouteInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShareWithCardRouteInfoQuery, ShareWithCardRouteInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ShareWithCardRouteInfoQuery, ShareWithCardRouteInfoQueryVariables>(ShareWithCardRouteInfoDocument, baseOptions);
}
export type ShareWithCardRouteInfoQueryHookResult = ReturnType<typeof useShareWithCardRouteInfoQuery>;
export type ShareWithCardRouteInfoLazyQueryHookResult = ReturnType<typeof useShareWithCardRouteInfoLazyQuery>;
export type ShareWithCardRouteInfoQueryResult = Apollo.QueryResult<ShareWithCardRouteInfoQuery, ShareWithCardRouteInfoQueryVariables>;
export const ShareWebsiteUpdateEventHandleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ShareWebsiteUpdateEventHandle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'website' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWebsiteHandle' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'website' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'website' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ShareWebsiteUpdateEventHandleMutationFn = Apollo.MutationFunction<ShareWebsiteUpdateEventHandleMutation, ShareWebsiteUpdateEventHandleMutationVariables>;

/**
 * __useShareWebsiteUpdateEventHandleMutation__
 *
 * To run a mutation, you first call `useShareWebsiteUpdateEventHandleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareWebsiteUpdateEventHandleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareWebsiteUpdateEventHandleMutation, { data, loading, error }] = useShareWebsiteUpdateEventHandleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useShareWebsiteUpdateEventHandleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ShareWebsiteUpdateEventHandleMutation, ShareWebsiteUpdateEventHandleMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ShareWebsiteUpdateEventHandleMutation, ShareWebsiteUpdateEventHandleMutationVariables>(ShareWebsiteUpdateEventHandleDocument, baseOptions);
}
export type ShareWebsiteUpdateEventHandleMutationHookResult = ReturnType<typeof useShareWebsiteUpdateEventHandleMutation>;
export type ShareWebsiteUpdateEventHandleMutationResult = Apollo.MutationResult<ShareWebsiteUpdateEventHandleMutation>;
export type ShareWebsiteUpdateEventHandleMutationOptions = Apollo.BaseMutationOptions<ShareWebsiteUpdateEventHandleMutation, ShareWebsiteUpdateEventHandleMutationVariables>;
